document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-rsh]').forEach(initRotatingSplitHero);
});

function initRotatingSplitHero(root) {
  const slides = Array.from(root.querySelectorAll('[data-rsh-slide]'));
  if (slides.length < 2) return;

  const dots = Array.from(root.querySelectorAll('[data-rsh-dot]'));

  const prevBtn = root.querySelector('[data-rsh-prev]');
  const nextBtn = root.querySelector('[data-rsh-next]');
  const autoplay = root.dataset.autoplay === 'true';
  const interval = parseInt(root.dataset.interval, 10) || 8000;

  let current = slides.findIndex((s) => s.classList.contains('is-active'));
  if (current < 0) current = 0;

  let timer = null;

  function goTo(index, { restart = true } = {}) {
    const next = (index + slides.length) % slides.length;
    if (next === current) return;
    slides[current].classList.remove('is-active');
    slides[next].classList.add('is-active');
    current = next;
    updateDots();
    if (restart) restartTimer();
  }

  function updateDots() {
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === current);
    });
  }

  function next() {
    goTo(current + 1);
  }

  function prev() {
    goTo(current - 1);
  }

  function startTimer() {
    if (!autoplay) return;
    timer = window.setInterval(next, interval);
  }

  function stopTimer() {
    if (timer) {
      window.clearInterval(timer);
      timer = null;
    }
  }

  function restartTimer() {
    stopTimer();
    startTimer();
  }

  nextBtn && nextBtn.addEventListener('click', () => goTo(current + 1));
  prevBtn && prevBtn.addEventListener('click', () => goTo(current - 1));

  dots.forEach((dot, i) => {
    dot.addEventListener('click', () => goTo(i));
  });

  // Pause on hover/focus so people can read without the slide changing underneath them
  root.addEventListener('mouseenter', stopTimer);
  root.addEventListener('mouseleave', startTimer);
  root.addEventListener('focusin', stopTimer);
  root.addEventListener('focusout', startTimer);

  // Set initial dot state in case the active slide isn't the first one
  updateDots();

  startTimer();
}